import ImageAndText from '../../components/ImageAndText/ImageAndText'
import FeatureStrip from '../../components/FeatureStrip/FeatureStrip'
import Hero from '../../components/Hero/Hero'
import VerticalTextWithImage from '../../components/VerticalTextWithImage/VerticalTextWithImage'
import FaqStrip from '../../components/FaqStrip/FaqStrip'
import HowToGuideStrip from '../../components/HowToGuide/HowToGuideStrip/HowToGuideStrip'
import SalaryBands from '../../components/SalaryBands/SalaryBands'
import QuoteHero from '../../components/QuoteHero/QuoteHero'
import PageTitle from '../../components/PageTitle/PageTitle'
import FeedbackForm from '../../components/FeedbackForm/FeedbackForm'
import Glossary from '../../components/Glossary/Glossary'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Clients from '../../components/Clients/Clients'
import HowToGuides from '../../components/HowToGuide/HowToGuides'
import InitiativesChampions from '../../components/InitiativesChampions/InitiativesChampions'
import Review from '../../components/Review/Review'

export const components = {
  imageAndText: ImageAndText,
  featureStrip: FeatureStrip,
  hero: Hero,
  verticalTextWithImage: VerticalTextWithImage,
  faqStrip: FaqStrip,
  howToGuideStrip: HowToGuideStrip,
  salaryBandsCollection: SalaryBands,
  quoteHero: QuoteHero,
  pageTitle: PageTitle,
  feedbackForm: FeedbackForm,
  glossaryPage: Glossary,
  clientsGrid: Clients,
  howToGuidesPage: HowToGuides,
  championsPage: InitiativesChampions,
  reviewContainer: Review
}

export const formatDataForMyComponent = (component) => {
  switch (component.sys.contentType.sys.id) {
    case 'imageAndText':
      return {
        flip: !component.fields.imageDisplay,
        title: component.fields.title,
        imageProps: {
          src: component.fields.image.fields.file.url,
          alt: component.fields.image.fields.description
        },
        ctaProps: component.fields.linkDisplayText &&
          component.fields.linkUrl && {
            text: component.fields.linkDisplayText,
            href: component.fields.linkUrl,
            external: !component.fields.isInternalLink
          },
        children: documentToReactComponents(component.fields.text)
      }
    case 'verticalTextWithImage':
      return {
        title: component.fields.title,
        description: documentToReactComponents(component.fields.description),
        image: component.fields.appImage.fields.file.url,
        imageAlt: component.fields.appImage.fields.description
      }

    case 'featureStrip':
      return {
        ctaUrl: component.fields.ctaUrl,
        ctaText: component.fields.ctaText,
        externalUrl: component.fields.externalUrl,
        title: component.fields.title,
        featureItems: component.fields.featureItems.map((featureItem) => ({
          title: featureItem.fields.title,
          imgSrc: featureItem.fields.image.fields.file.url,
          imgAlt: featureItem.fields.image.fields.description,
          style: {
            backgroundColor: featureItem.fields.backgroundColour
          }
        })),
        text: component.fields.bodyCopy
      }

    case 'hero':
      return {
        title: component.fields.title,
        imageProps: {
          desktopImage: {
            src: component.fields.desktopImage.fields.file.url,
            alt: component.fields.desktopImage.fields.description
          },
          mobileImage: {
            src: component.fields.mobileImage.fields.file.url,
            alt: component.fields.mobileImage.fields.description
          }
        },
        text: documentToReactComponents(component.fields.text)
      }

    case 'faqStrip':
      return {
        title: component.fields.title,
        questions: component.fields.questions.map((question) => ({
          question: question.fields.question,
          answer: question.fields.answer,
          infoLink: question.fields.infoLink,
          infoLinkText: question.fields.infoLinkText
        }))
      }
    case 'howToGuideStrip':
      return {
        ctaUrl: component.fields.ctaUrl,
        ctaText: component.fields.ctaText,
        title: component.fields.title,
        howToGuideCards: component.fields.howToGuideCards.map((data) => ({
          url: data.fields.guideUrl,
          icon: data.fields.guideIcon,
          heading: data.fields.guideHeading,
          description: data.fields.guideDescription
        })),
        text: component.fields.text,
        isExternal: component.fields.iSexternal
      }

    case 'salaryBandsCollection':
      return {
        salaryBands: component.fields.salaryBands.map((salaryBand) => ({
          ...salaryBand.fields,
          position: salaryBand.fields.positionWithinLevel
        }))
      }

    case 'quoteHero':
      return {
        title: component.fields.title,
        quote: component.fields.quote,
        author: component.fields.author
      }

    case 'pageTitle':
      return {
        title: component.fields.title,
        text: documentToReactComponents(component.fields.text)
      }
    case 'feedbackForm':
      return {
        url: component.fields.url
      }
    case 'glossaryPage':
      return {
        title: component.fields.title,
        glossaryItems: component.fields.glossaryItems.map((item) => ({
          ...item.fields
        })),
        footerHeading: component.fields.footerHeading,
        footerText: component.fields.footerText
      }
    case 'clientsGrid':
      return {
        title: component.fields.title,
        clientData: component.fields.reference.map((item) => ({
          ...item.fields
        }))
      }

    case 'howToGuidesPage':
      return {
        title: component.fields.title,
        templateIcon: component.fields.templateIcon.fields.file.url,
        contactsIcon: component.fields.contactsIcon.fields.file.url,
        guidesIcon: component.fields.guidesIcon.fields.file.url,
        listsIcon: component.fields.listsIcon.fields.file.url,
        otherIcon: component.fields.otherIcon.fields.file.url,
        guideData: component.fields.howToGuideCards.map((data) => ({
          url: data.fields.guideUrl,
          icon: data.fields.guideIcon,
          heading: data.fields.guideHeading,
          description: data.fields.guideDescription,
          type: data.fields.type
        }))
      }
    case 'championsPage':
      return {
        championCards: component.fields.championsCards.map((data) => ({
          title: data.fields.title,
          how: data.fields.how,
          why: data.fields.why,
          who: data.fields.who,
          link: data.fields.links
        }))
      }
    case 'reviewContainer':
      return {
        reviews:component.fields
      }
    default:
      return {}
  }
}
